<template>
  <div
    class="bonus-list page-box"
    :class="{'en-us': language == 'en_US'}"
  >
    <query-header
      ref="queryheader"
      :mt4-account-options="queryAccountList"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input"
          v-model="ruleName"
          :placeholder="phFileter('bonusList.Deposit_Activity_Account')"
          clearable
        ></el-input>
        <vs-button
          class="search-btn"
          @click="searchHandle"
        >{{$t('search')}}</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead">
            <vs-th>
              {{'ID'}}
            </vs-th>
            <vs-th>
              {{$t('bonusList.Deposit_account')}}
            </vs-th>
            <vs-th>
              {{$t('bonusList.Activity_Account')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.EventName')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.BonusType')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.BonusAmount')}}(USD)
            </vs-th>
            <vs-th>
              {{$t('withgold.DepositAmount')}}(USD)
            </vs-th>

            <vs-th>
              {{$t('withgold.NumberOfLots')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.LotsCompleted')}}
            </vs-th>
            <vs-th>
              {{$t('bonusList.Deposit_Time')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.ExpireDate')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.status')}}
            </vs-th>
            <vs-th>
              {{$t('operate')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.login}}
              </vs-td>
              <vs-td>
                {{tr.login}}
              </vs-td>
              <vs-td>
                {{tr.ruleName}}
              </vs-td>
              <vs-td>
                <span>{{getType(tr.giveType)}}</span>
              </vs-td>

              <vs-td>
                {{tr.moneyNumber}}
              </vs-td>
              <vs-td>
                {{tr.goldEntry}}
              </vs-td>

              <vs-td>
                <span>{{getSuccessNumber(tr)}}</span>
              </vs-td>
              <vs-td>
              <span
                :class="{
                    pointer: tr.completeNumber > 0,
                    'theme-font': tr.completeNumber > 0,
                    }"
                @click="completeNumberHandle(tr)"
              >{{getCompleteNumber(tr)}}</span>
              </vs-td>
              <vs-td>
                <span
                  v-if="tr.goldEntryTime"
                  class="">{{parseTime(tr.goldEntryTime)}}</span>
                <span
                  v-else
                >-</span>
              </vs-td>
              <vs-td>
                <span>{{getEndTime(tr)}}</span>
              </vs-td>
              <vs-td>
                <span>{{getStatus(tr.status,self)}}</span>
                <el-tooltip placement="top" v-if="tr.status == 5">
                  <div slot="content">
                    {{$t('withgold.freeStatusTipsOne')}}
                    <br/>{{$t('withgold.freeStatusTipsTwo')}}
                    <br/>{{$t('withgold.freeStatusTipsThree')}}
                  </div>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </vs-td>
              <vs-td>
<!--
不同状态显示不同操作
【进行中】：取消赠金
【已达标】：申请转正
【已冻结】：取消信用额
【转正审核】【转正通过】【转正拒绝】【已结束】：不显示操作
todo
-->
                <el-button
                  round
                  v-if="tr.status == 3"
                  class="btn-el"
                  type="primary"
                  size="mini"
                  @click="cancelBonusHandle(tr)"
                >{{$t('bonusList.Cancel_bonus')}}</el-button>
                <el-button
                  v-if="tr.status == 6"
                  class="btn-el"
                  round
                  type="primary"
                  size="mini"
                  @click="applyTurnHandle(tr)"
                >{{$t('bonusList.Apply_for_regularization')}}</el-button>
                <el-button
                  v-if="tr.status == 5"
                  round
                  class="btn-el"
                  type="primary"
                  size="mini"
                  @click="cancleCreditHandle(tr)"
                >{{$t('bonusList.Cancel_credit')}}</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}}&nbsp;{{total}}&nbsp;{{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
      <expenience-tranfer-dialog
        ref="expeniencedialog"
        :row-data="currentRowData"
        :dialog-show="transferDialogShow"
        @close="closeHandle"
        @roll-out="rollOutHandle"
      ></expenience-tranfer-dialog>
    </div>
  </div>
</template>

<script>
import { getStatus } from '@/views/customer/bonusManage/common'
import { getTradeHistoryAccountList } from '@/api/user';
import expenienceTranferDialog from "@/components/bonusManage/expenienceTranferDialog";
import { transferCredits, cancleCredits } from '@/api/userCenter'
import { parseTime } from "@/utils";
import { mapGetters } from 'vuex'
import initData from "@/mixins/initData";
import queryHeader from "@/components/bonusManage/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
    expenienceTranferDialog,
  },
  props: {
    isAgentPage: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      ruleName: '',
      transferDialogShow: false,
      currentRowData: null,
      queryAccountList: [],
      self: {},
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo','language']),
  },
  created(){
    this.self = this;
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    getStatus,
    phFileter(data){
      return this.$t(data)
    },
    beforeInit(){
      this.url = '/crm/reception/queryRecordByUserId'; // 赠金历史
      this.params = {
        page: this.page - 1,
        size: this.size,
        userId: this.userInfo.id,
      }
      let header = this.$refs.queryheader;

      header.sendGoldType && (this.params.giveType = header.sendGoldType);
      this.ruleName && (this.params.ruleName = this.ruleName);
      if(header.status !== ''){
        this.params.status = header.status;
      }

      if(header.date){
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      return true;
    },
    getType(giveType){
      return giveType == 1 ? this.$t('User.credit') : this.$t('User.commissionBanlance');
    },
    getSuccessNumber(row){
      if(row.giveType == 2){
        return '---'
      }else {
        return row.successNumber / 100;
      }
    },
    getCompleteNumber(row){
      if(row.giveType == 2){
        return '---'
      }else {
        return row.completeNumber && row.completeNumber / 100;
      }
    },
    completeNumberHandle(row){

      if(row.completeNumber <= 0) return;
      // 跳转的页面 todo

      this.$router.push({name: 'doLot', params:{id: row.id},query:{login: row.depositLogin}});
    },
    getEndTime(row){
      if(row.giveType == 2){
        return '---'
      }else {
        if(row.endTime){
          return this.parseTime(row.endTime);
        }else {
          return '-';
        }
      }
    },
    transferHandle(row){
      if(row.giveType !== 3){
        this.$confirm(`<p class="center sendGoldHistory-transfer-p">${this.$t('withgold.sureTitle1')}$${row.moneyNumber} </p><p class="theme-font center sendGoldHistory-transfer-p">${this.$t('withgold.sureTitle2')}</p>`,this.$t('withgold.sureTitleCenter'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'self-messagebox-wrapper sendGoldHistory-messagebox'
        }).then(() => {
          //点击确定的操作(调用接口)
          transferCredits({
            id: row.id,
          }).then((res) => {
            this.init();
            this.$message({
              type: 'success',
              message: this.$t('withgold.operatingSuccess')
            })
          })
        }).catch(() => {
          //几点取消的提示
        });
      }else {
        this.currentRowData = row;
        this.transferDialogShow = true;
      }
    },
    getCancleBtnShow(row){
      return row.giveType !==3 && (row.status == 5 || row.status == 3)
    },
    // 取消赠金
    cancelBonusHandle(row){
      this.$confirm(this.$t('withgold.cancleTitle'),this.$t('root.confirm')+ this.$t('root.cancle'), {
        confirmButtonText: this.$t('root.confirm'),
        cancelButtonText: this.$t('root.cancle'),
        type: 'warning',
        customClass: 'self-messagebox-wrapper sendGoldHistory-messagebox'
      }).then(() => {
        //点击确定的操作(调用接口)
        cancleCredits({
          status: 7,
          id: row.id,
        }).then((res) => {
          this.init();
          this.$message({
            type: 'success',
            message: this.$t('withgold.operatingSuccess')
          })
        })
      }).catch(() => {
        //几点取消的提示
      });
    },

    //  申请转正
    applyTurnHandle(row){
      this.transferHandle(row);
    },
    // 取消信用额
    cancleCreditHandle(row){
      this.cancleHandle(row);
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    closeHandle(){
      this.transferDialogShow = false;
    },

    rollOutHandle(params){
      let paramsData = {
        id: this.currentRowData.id,
        type: params.type,
      };
      if(params.type == 2){
        paramsData.targetLogin = params.targetLogin;
      }
      this.$refs.expeniencedialog.saveLoading = true;
      transferCredits(paramsData).then((res) => {
        this.$refs.expeniencedialog.saveLoading = false;
        this.transferDialogShow = false;
        this.init();
        this.$message({
          type: 'success',
          message: this.$t('withgold.operatingSuccess')
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.bonus-list {
  /deep/ .btn-el {
    span {
      color: #ffffff!important;
    }
  }
  .vs-con-table {
    min-width: 1400px;
  }
  &.en-us {
    .vs-con-table {
      min-width: 1700px;
    }
  }
}
</style>
